import { AxLoad } from "./Lib/AxSystem/AxLoad";
import { AxLimeStone } from "./Limestone/AxLimeStone";
import { AxProdDetail } from "./Modules/AxProdSelection/AxProdDetail";
import { AxProdMain } from "./Modules/AxProdSelection/AxProdMain";
import { AxPackNonPredateable } from "./Modules/AxProdSelection/Packages/AxPackNonPredateable";
import { AxPackPredateable } from "./Modules/AxProdSelection/Packages/AxPackPredateable";
import { AxProdNonPredateable } from "./Modules/AxProdSelection/Tickets/AxProdNonPredateable";
import { AxProdPredateable } from "./Modules/AxProdSelection/Tickets/AxProdPredateable";
import { AxProdSelection } from "./Modules/AxProdSelection/AxProdSelection";
import { AxProdSelectionCalendar } from "./Modules/AxProdSelection/Tickets/AxProdSelectionCalendar";
import { AxProdBooking } from "./Modules/AxProdSelection/Tickets/AxProdBooking";
import { AxProdSummary } from "./Modules/AxProdSelection/AxProdSummary";
import { AxTopBar } from "./Modules/Global/AxTopBar";
import { AxMain } from "./Utility/AxMain";
import { AxPackSelectionCalendar } from "./Modules/AxProdSelection/Packages/AxPackSelectionCalendar";
import { B2bMode } from "./Modules/B2B/B2bMode"
import { ShoppingCart } from "./Modules/ShoppingCart/ShoppingCart";
import { AxPackBooking } from "./Modules/AxProdSelection/Packages/AxPackBooking";
import { TimeSlots } from "./Modules/Reservations/TimeSlots";
import { Reserved } from "./Modules/Reservations/Reserved";
import { CategoryFilter } from "./Modules/Categories/CategoryFilter";
import { SubmenuAim } from "./Modules/Global/SubmenuAim";
import { RetailDetail } from "./Modules/Retail/RetailDetail";
import { RetailMain } from "./Modules/Retail/RetailMain";
import { Shipping } from "./Modules/Shipping/Shipping";
import { RetailFilter } from "./Modules/Retail/RetailFilter";
import { OrderHistory } from "./Modules/Profile/OrderHistory";
import { AxBirthDateInputTriple } from "./Modules/Global/AxBirthDateInputTriple";
import { MainGiftCards } from "./Modules/GiftCard/MainGiftCards";
import { PersonalizeGiftCard } from "./Modules/GiftCard/PersonalizeGiftCard";
import { PasswordValidation } from "./Modules/Profile/PasswordValidation";
import { MyFamily } from "./Modules/Profile/MyFamily";
import { SeasonCardBooking } from "./Modules/Reservations/SeasonCardBooking";
import { ComplexPackageFilter } from "./Modules/ComplexPackages/ComplexPackageFilter";
import { ComplexPackageSelection } from "./Modules/ComplexPackages/ComplexPackageSelection";
import { ComplexPackageDetails } from "./Modules/ComplexPackages/ComplexPackageDetails";
import { ComplexPackageBookingOptions } from "./Modules/ComplexPackages/ComplexPackageBookingOptions";
import { ComplexPackageBookingTicketsOptions } from "./Modules/ComplexPackages/BookingOptions/ComplexPackageBookingTicketsOptions";
import { CompPackBookingLessonProgramOptions } from "./Modules/ComplexPackages/BookingOptions/CompPackBookingLessonProgramOptions";
import { CompPackBookingPersonOptions } from "./Modules/ComplexPackages/BookingOptions/CompPackBookingPersonOptions";
import { CompPackBookingRentalOptions } from "./Modules/ComplexPackages/BookingOptions/CompPackBookingRentalOptions";
import { CompPackBookingLessonOptions } from "./Modules/ComplexPackages/BookingOptions/CompPackBookingLessonOptions";
import { Redirect } from "./Modules/Redirect/Redirect";
import { ComplexPackageSearchBar } from "./Modules/ComplexPackages/ComplexPackageSearchBar";
import { LessonsLoadingSpinner } from "./Modules/Lessons/LessonsLoadingSpinner";
import { Eguma } from "./Modules/Payment/Eguma";
import { ShoppingCartPersonalisation } from "./Modules/ShoppingCart/ShoppingCartPersonalisation";
import { ShoppingCartReservationTimer } from "./Modules/ShoppingCart/ShoppingCartReservationTimer";
import { B2BHistory } from "./Modules/B2B/B2BHistory";
import { ShoppingCartEntryRetail } from "./Modules/ShoppingCart/ShoppingCartEntryRetail";
import { FindMyTicket } from "./Modules/FindMyTicket/FindMyTicket";
import { MyChipCards } from "./Modules/Profile/MyChipCards";
import { UtilityInit } from "./Modules/Global/UtilityInit";
import { AxFireShoppingCartModal } from "./Components/AxFireShoppingCartModal/AxFireShoppingCartModal";
import { inputMaskHelper } from './Lib/Helper/InputMaskHelper';
import { AxGA4Module } from "./Modules/AxGA4/AxGA4Module";
import { AxStaticConfigModule } from "./Modules/AxConfig/AxStaticConfigModule";
import { ServerErrorPopUp } from "./Modules/ErrorHandling/ServerErrorPopUp";
import { VoucherPayment } from "./Modules/Payment/VoucherPayment";
import { Unsubscribe } from "./Modules/NewsLetterSubscription/Unsubscribe";
import { Banner } from "./Modules/Global/Banner";
import { HeroModule } from "./Modules/Hero/HeroModule";
import { Payment } from "./Modules/Payment/Payment";
import { Registration } from "./Modules/Account/Registration";
import { RegisterForm } from "./Modules/Account/RegisterForm";
import { PersonalData } from "./Modules/ProfileSettings/PersonalData"; 
import { Resubscribe } from "./Modules/NewsLetterSubscription/Resubscribe";
import { PackageMinMaxConstraint } from "./Modules/Packages/PackageMinMaxConstraint";
import { MissingMandatoryData } from "./Modules/Account/MissingMandatoryData";
import { MaintenanceScriptInfo } from "./Modules/MaintenanceMode/MaintenanceScriptInfo";
import { RentalMain } from "./Modules/Rental/RentalMain";
import { RentalFilter } from "./Modules/Rental/RentalFilter";
import { LocalizationModule } from "./Modules/Global/LocalizationModule";
import { BleQrCodes } from "./Modules/Ble/BleQrCodes";
import { ShoppingCartDateInputTriple } from "./Modules/ShoppingCart/ShoppingCartDateInputTriple";
import { RentalProductDetails } from "./Modules/Rental/ProductDetails/RentalProductDetails";
import { DateModule } from "./Modules/Global/DateModule";
import { RentalShopDetails } from "./Modules/Rental/RentalShopDetails";
import * as RentalDetails from "./Modules/Rental/RiderDetails/RiderDetailsModule";
import * as LessonPackagesLandingPage from "./Modules/LessonPackages/LandingPage";
import * as LessonPackagesSelection from "./Modules/LessonPackages/Selection";
import * as LessonPackagesPersonalization from "./Modules/LessonPackages/Personalization";
import { AxFilterOverlay } from "./Utility/AxFilterOverlay";
import { LessonPackageStorage } from "./Modules/LessonPackages/LessonPackageStorage";
import { ToCheckout } from "./Modules/ShoppingCart/ToCheckout";
import { PopUpShoppingCart } from "./Modules/ShoppingCart/PopUpShoppingCart";
import { OneRiskNotification } from "./Modules/ShoppingCart/OneRiskNotification";
import { OneRisk } from "./Modules/OneRisk/OneRisk";
import { CustomerLessonProperties } from "./Modules/Account/CustomerLessonProperties";
import { LessonBuyerInfoModule } from "./Modules/Lessons/LessonBuyerInfoModule";
import { ConsentDocuments } from "./Modules/ConsentDocuments/ConsentDocuments";
import * as LandingQuickSelection from "./Modules/AxProdSelection/LandingQuickSelection";

export class App extends AxMain {
    declarations = [
        Payment,
        AxTopBar,
        AxProdDetail,
        AxProdMain,
        AxProdSelection,
        LessonPackagesLandingPage.LandingPage,
        LessonPackagesSelection.Selection,
        LessonPackagesPersonalization.Personalization,
        AxProdSelectionCalendar,
        AxProdBooking,
        AxPackBooking,
        AxProdNonPredateable,
        AxProdSummary,
        LandingQuickSelection.LandingQuickSelection,
        AxProdPredateable,
        AxPackPredateable,
        AxPackNonPredateable,
        AxPackSelectionCalendar,
        ShoppingCart,
        CategoryFilter,
        ToCheckout,        
        RentalShopDetails,
        Registration,
        B2BHistory,
        ShoppingCart,
        SeasonCardBooking,
        TimeSlots,
        LessonPackageStorage,
        VoucherPayment,
        Reserved,
        OrderHistory,
        ComplexPackageFilter,
        ComplexPackageSelection,
        ConsentDocuments,
        ComplexPackageDetails,
        Eguma,
        AxBirthDateInputTriple,
        SubmenuAim,
        RetailDetail,
        RetailMain,
        RetailFilter,
        RentalMain,
        RentalFilter,
        Shipping,
        OrderHistory,
        ComplexPackageBookingOptions,
        ComplexPackageBookingTicketsOptions,
        CompPackBookingLessonProgramOptions,
        CompPackBookingPersonOptions,
        CompPackBookingRentalOptions,
        CompPackBookingLessonOptions,
        PasswordValidation,
        MyChipCards,
        Redirect,
        LessonsLoadingSpinner,
        MyFamily,
        ShoppingCartEntryRetail,
        ComplexPackageSearchBar,
        ShoppingCartPersonalisation,
        FindMyTicket,
        UtilityInit,
        ShoppingCartReservationTimer,
        PersonalizeGiftCard,
        MainGiftCards,
        AxFireShoppingCartModal,
        AxGA4Module,
        AxStaticConfigModule,
        ServerErrorPopUp,
        HeroModule,
        Banner,
        Unsubscribe,
        Resubscribe,
        PersonalData,
        MissingMandatoryData,
        MaintenanceScriptInfo,
        PopUpShoppingCart,
        RegisterForm,
        PackageMinMaxConstraint,
        BleQrCodes,
        ShoppingCartDateInputTriple,
        RentalProductDetails,
        LocalizationModule,
        RentalDetails.RiderDetailsModule,
        DateModule,
        OneRiskNotification,
        OneRisk,
        CustomerLessonProperties,
        LessonBuyerInfoModule
    ];

    utility = [
        inputMaskHelper,
        AxFilterOverlay,
        AxLimeStone
    ];

    providers = [
        AxLoad,
        B2bMode
    ];

    constructor() {
        super();
        this.Init();
    }
}


window["App"] = App;